import React from 'react';
import useZibi from "../../../zibi/UseZibi";
import styled from "styled-components";
import Field from "./Field";
import {useLocation} from "react-router-dom";
import {getQueryValue} from "../../../domain/queryHandler";

const WrapperStyled = styled.div`
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    display: grid;
    grid-gap: 15px;
`;

const Fields = () => {
    const location = useLocation();

    const edgeId = getQueryValue(location, 'edge');

    const [siteFields] = useZibi('siteFields');

    const filtered = edgeId ? siteFields.filter(field => field.edgeId === edgeId): siteFields;

    return (
        <WrapperStyled>
            {filtered && filtered.map((edge) => {
                return (
                    <Field
                        key={edge._id}
                        item={edge}
                    />
                );
            })}
        </WrapperStyled>
    );
};

export default Fields;